import { render, staticRenderFns } from "./SlcNewsItemLong.vue?vue&type=template&id=a966513a&"
import script from "./SlcNewsItemLong.vue?vue&type=script&lang=ts&"
export * from "./SlcNewsItemLong.vue?vue&type=script&lang=ts&"
import style0 from "./SlcNewsItemLong.vue?vue&type=style&index=0&postcss=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})
